import { createStore } from 'vuex'

export default createStore({
  state: {
    imgPath: 'https://service.psa-ict.co.kr/static/www/image/',
    videoPath: 'https://service.psa-ict.co.kr/static/www/video/',
    filePath: 'https://service.psa-ict.co.kr/static/www/file/',
    boardFilePath: 'https://service.psa-ict.co.kr/ictdoc/files/file/'
  },
  getters: {
    getUrlPath (state) {
      return state.urlpath
    },
    getImgPath (state) {
      return state.urlpath + state.imgPath
    },
    getVideoPath (state) {
      return state.urlpath + state.videoPath
    }
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
